import React from 'react';

const Art = (props) => {
    return (
        <div className={`artwork artwork-${props.type}`} aria-hidden="true">
            <img src={props.art} alt="" loading="lazy" decoding="async" />
        </div>
    );
};

export default Art;
